import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import { useDispatch, useSelector } from "react-redux";
import {
  handleDisableFilter,
  setBlobFilterStates,
} from "~/Pages/Process/actions/attachmentsSlice";
import FolderListSection from "~/components/folder-list-section/FolderListSection";

const ServiceFileDocuments = () => {
  const { id, service_id } = useParams();
  const { blobFilterStates } = useSelector((state) => state.attachments);
  const dispatch = useDispatch();
  const {
    states,
    handleClickServiceProcess,
    handleClickServiceSubFolder,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
  } = useFileDocuments({
    id,
    service_id,
  });
  useEffect(() => {
    dispatch(setBlobFilterStates({}));
  }, []);
  useEffect(() => {
    dispatch(handleDisableFilter(!states?.folders?.length));
  }, [states?.folders]);
  return (
    <FolderListSection
      folders={states?.folders}
      loading={states.loading}
      isFilterApplied={!!blobFilterStates?.selectedItems?.length}
      onFolderClick={
        states.selectedService?.name === "Core Entity Information"
          ? handleClickServiceSubFolder
          : handleClickServiceProcess
      }
      showEmptyState={true}
      filterContent={
        <SearchFIles
          fileName={fileName}
          setFileName={setFileName}
          additionaltag={{ entity: [states?.entity_detail?.name] }}
          states={states}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          isRootFolder={true}
        />
      }
    />
  );
};

export default ServiceFileDocuments;
